import CheckBox from 'components/checkbox'
import Header from 'components/header'
import SideBar from 'components/siderbar'
import { NotificationContext } from 'context/notification_context'
import React, { use, useContext, useEffect, useState } from 'react'
import { Button, ListGroup } from 'react-bootstrap'
import { BsLink, BsTrash } from 'react-icons/bs'
import { FaEdit } from 'react-icons/fa'
import { MdDelete, MdEdit } from 'react-icons/md'
import { useNavigate, useParams } from 'react-router'
import { Service } from 'services/api'
import { DDMMYYYY } from 'utils/functions'
import Renderif from 'utils/renderif'

export default function QuestionView() {

const navigate = useNavigate()
   const {id_activity} = useParams()
    
    const [file, setFile] = useState(null)
    const {notify} = useContext(NotificationContext)
    const [state, setState] = useState({
        step:0,
        idQuestion:null,
        activity:null,
        question:{
            question:"",
            image:"image",
            idQuestionCategory:null,
            idAnswer:null,
            idActivity:id_activity
        }, 
        answer:{
            answer:"",
            image:"Image",
        },
        answers:[],
        questions:[]
        
    })

    useEffect(()=>{
        init()
        return () => {}
    },[])
    useEffect(()=>{
        console.log(file?.filename)
    },[file])

    const init = async () => {

        let _activity = await Service('GET', `activity/${id_activity}`)
        console.log(_activity.data.data)
        state.activity = _activity.data.data
        state.questions = _activity.data.data.questions

        let _question = await Service('GET', `question/2`)
        console.log(_question)
        setFile(null)
        setState({...state})

    }

    const onCreateQuestion = async () => {

        
        let body = {
            ...state.question
        }

        if(file !== null){
            let _upload = await upLoad()
            body.image = _upload.data;
        }


        body.idActivity = parseInt(body.idActivity)
        console.log(body)

        let _create_question = await Service('POST', `question`, body)
        if(_create_question.status === 201){
            notify({title:"Nueva pregunta", message:"Pregunta creada exitosamente.", type:'success'})
            navigate(`/answer/${id_activity}/${_create_question.data.data.id}`)

        }
        // navigate(`/answer/${id_activity}/${_create_question.data.data.id}`)
        // console.log(_create_question)
        // init();
    }

    const onCreateAnswer = async () => {
        
        let body = {
            ...state.answer
        }
        body.idQuestion = state.idQuestion
        
        if(file !== null){
            let _upload = await upLoad()
            body.image = _upload.data;
        }

        console.log(body)

        let _create_answer = await Service('POST', `answer`, body)
  
        state.answer.answer=""
        state.answer.image="Image"

        
    
        // loadQuestion(state.idQuestion)
        // init();

    }

    const loadQuestion = async (id_question) => {
        let _question = await Service('GET', `question/${id_question}`)
        state.idQuestion = id_question
        state.answers = _question.data.data.options

        setState({...state})
    }

    const upLoad = async () => {
        
        let body = new FormData();
        body.append("file", file);
        return await Service('POSTMEDIA', `upload`, body )
        
        // return await Service('POSTMEDIA', `document/upload/${type}`, body )

        // let _upload = await Service('POSTMEDIA', 'upload') 
    } 
    const getStatus = (status) => {
        switch (status) {
            case null:
                
               return "Sin publicar"
                case false:
                
                return "Sin publicar"
                    case true:
                
                    return "Publicado"

            default:
                break;
        }
    }
    const publish = async (value) => {
        let body = {
            status:value
        }
        let _activity_publish = await Service('PATCH', `activity/${id_activity}`, body)
        if(_activity_publish.status === 200){
            if(value){
                notify({title:"Publicar", message:"Dinámica publicada exitosamente.", type:'success'})
            }else{
                notify({title:"Despublicar", message:"Dinámica despublicada exitosamente.", type:'success'})  
            }
        }
        init()
    }
    const onDeleteActivity = async () => {
        let _activity_delete = await Service('DELETE', `activity/${id_activity}`)
        console.log(_activity_delete)
        navigate('/home')
    }
    const onDeleteQuestion = async (id) => {
        let _delete = await Service('DELETE', `question/${id}`)
        if(_delete.status === 200){
            notify({title:"Preguntas", message:"Pregunta eliminada exitosamente.", type:'success'})
            init()
        }
      }
   
  
  return (
    <div className='container-fluid d-flex p-0'>
        <SideBar></SideBar>

        <div className='col overflow-auto'>

        <Header showback={false} title={state.activity?.name} subtitle="Dinámica" />


        <div className='container-md mt-5'>

            <div className='d-flex align-items-center bg-white-alpha-05 overflow-hidden r-10'>
            
                <div className='thumbnail--md' style={{backgroundImage: `${state.activity?.image === null ? 'url(/images/dinamica_name.jpeg)' : `url(${state.activity?.image})` }`}}></div>

                <div className='col px-3'>
                    <div className='f-22 bold'>{state.activity?.name}</div>
                 
                    <div className='f-14 bold'>{DDMMYYYY(state.activity?.expiration)}</div>
                    <div className='f-22 bold mt-2'>{state.activity?.status}</div>
                    <div className={`tag tag--${state.activity?.status === true ? 'green' : 'gray'}`}>{getStatus(state.activity?.status)}</div>
                    
                </div>

                <div className='mx-3 d-flex'>
                    <Renderif isTrue={state.activity?.status !== true}>
                        <Button className='' onClick={()=>{
                            publish(true)
                        }}>Publicar</Button>
                    </Renderif>
                    <Renderif isTrue={state.activity?.status === true}>
                        <Button className='' onClick={()=>{
                            publish(false)
                        }}>Despublicar</Button>
                    </Renderif>
                    <div className='icon bg-white ms-3 cursor-pointer' onClick={()=>{
                        onDeleteActivity()
                    }}>
                        <MdDelete color='red' size={18}></MdDelete>
                    </div>
                    <div className='icon bg-white cursor-pointer' onClick={()=>{
                            navigate('/dinamica', {state: {activity:state.activity}})
                            
                        }}>
                                <MdEdit size={16} color='#35CBCC'></MdEdit>
                        </div>
                </div>

            </div>

        </div>

       <Renderif isTrue={state.activity?.status}>
        <div className='container-md mt-3'>
                <div className='bg-white-alpha-05 d-flex align-items-center r-10 p-3'>
                    <div className='f-16 text-note'>{`https://yelmo.gyh.mx/app/${id_activity}`}</div>
                    <div className='col'></div>
                    <div>
                        <BsLink size={24} color=''></BsLink>
                    </div>
                </div>
            </div>
       </Renderif>


        

        <div className='container-md mt-3 d-none'>

            <div className='bg-white-alpha-05 r-10 p-3'>

            <div className=''>
                <div className='f-14 bold my-1'>Escribe tu pregunta</div>
                <input type='text' className='form-control' value={state.question?.question} onChange={(evt)=>{
                    
                    state.question.question = evt.currentTarget.value
                    setState({...state})
                }}></input>
            </div>


            <div>
                <div className='f-14 bold my-1'>Agrega una imagen a tu pregunta</div>
                <input type='file' className='form-control'  onChange={(evt)=>{
                    setFile(evt.currentTarget.files[0])
                    
                }}></input>
            </div> 

            <div className='mt-3'>
                <Button variant="primary" onClick={() => {
                    onCreateQuestion()
                    // setState({...state, step:1})
                }}>
                    + Pregunta
                </Button>
             
            </div>

   

            <table className='table mt-3 r-5 overflow-hidden'>
                    <thead>
                        <tr>
                            <th><div className='f-14 bold'>Image</div></th>
                            <th><div className='f-14 bold'>Pregunta</div></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {state.questions.map((question, i)=>{
                            return (
                                <tr className=''>
                                    <td>
                                        <Renderif isTrue={question.image !== "" && question.image !== null}>
                                            <img alt='' width={40} src={question.image}></img>
                                        </Renderif>
                                    </td>
                                    <td>{question.question}</td>
                                    <td>
                                      <div className='d-flex'>

                                        <div className='icon mx-3 cursor-pointer' onClick={()=>{
                                             navigate(`/answer/${id_activity}/${question.id}`)
                                          
                                        }}>
                                                <MdEdit size={16} color='white'></MdEdit>
                                        </div>


                                        <div className='icon bg-gray cursor-pointer' onClick={()=>{
                                            onDeleteQuestion(question.id)
                                        }}>
                                                <MdDelete size={16} color='red'></MdDelete>
                                        </div>
                                      </div>
                                    </td>
                                </tr>
                            )
                        })}
                  
                    </tbody>
            </table>

            </div>
        </div>



        

            


            
     

        </div>

    </div>
  )
}
